<template>

    <Grid>

        <Column v-for="(item, index) of data" :key="index" :span="[ 2, 4 ]" :push="[ 0, 1 ]">

            <AOS type="fade-up" duration="600" :delay="900">

                <div class="checklist__item py-6 px-6 flex md:items-center" :class="{ '--last': index === data.length-1 }">

                    <div class="h-5 w-5 sm:mt-2 mr-5" v-if="withIcon">

                        <Checkmark hollow class="h-5 w-5"/>

                    </div>

                    <Paragraph v-html="item"/>

                </div>

            </AOS>

        </Column>

    </Grid>

</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue'
    import Checkmark from './Icons/Checkmark.vue'
    import Column from './Grid/Column.vue'
    import Grid from './Grid/Grid.vue'
    import Paragraph from './Paragraph.vue'

    export default defineComponent({
        name: 'Checklist',
        props: {
            data: { type: Array as PropType<string[]>, required: true },
            withIcon: { type: Boolean, default: false }
        },
        components: {
            Checkmark,
            Column,
            Grid,
            Paragraph
        }
    })
</script>

<style lang="scss">

    @include component(checklist) {

        @include part(item) {

            border-top: 1px solid #000;
            border-right: 1px solid #000;
            border-left: 1px solid #000;

            @include option(last) {

                border-bottom: 1px solid #000;

            }

        }

    }

</style>
